/*
 * @Author: yuanxing(01407381)
 * @Date: 2023-05-10 11:20:31
 * @LastEditors: yuanxing(01407381)
 * @LastEditTime: 2023-05-10 11:26:03
 * @FilePath: \ibu-owt-core-frontend\utils\const\receiving_standard.js
 * @Description: 收寄标准查询
 */
export const standardKeywords = ["提单","海运提单","提單","海運提單","bill of lading","BL","ocean bill of lading","OBL"]